<div class="row">

    <div class="col-md-3">
      <div class="card" style="background-color: #3ec59d; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Total Patients</p>
              <h4 class="mb-0">2</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  
    <div class="col-md-3">
      <div class="card" style="background-color: #f3a8b5; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Today Patients</p>
              <h4 class="mb-0">1</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="col-md-3">
      <div class="card" style="background-color: #8197d1; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Last 7 Days Patients</p>
              <h4 class="mb-0">0</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="col-md-3">
      <div class="card" style="background-color: #fbd076; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Last 30 Days Patients</p>
              <h4 class="mb-0">12</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>

  <div class="row">

    <div class="col-md-3">
      <div class="card" style="background-color: #a698ee; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Total Amount</p>
              <h4 class="mb-0">2</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  
    <div class="col-md-3">
      <div class="card" style="background-color: #e3f3a8; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Today Amount</p>
              <h4 class="mb-0">1</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="col-md-3">
      <div class="card" style="background-color: #96d886; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Today upi Amount</p>
              <h4 class="mb-0">0</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="col-md-3">
      <div class="card" style="background-color: #feafe3; border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-1 overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Cash In Hand</p>
              <h4 class="mb-0">12</h4>
            </div>
            <div class="text-primary ms-auto">
              <i class=" font-size-24"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>

  <div class="container-fluid">
    <div class="row">
  
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Last 7 days Analysis</h4>
            <apx-chart class="apex-charts" dir="ltr" [series]="barChart.series" [chart]="barChart.chart"
              [plotOptions]="barChart.plotOptions" [dataLabels]="barChart.dataLabels" [xaxis]="barChart.xaxis"
              [colors]="barChart.colors" [grid]="barChart.grid"></apx-chart>
          </div>
        </div>
      </div>
      <!-- <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">User Analysis</h4>
            <apx-chart class="apex-charts" dir="ltr" [series]="simplePieChart.series" [chart]="simplePieChart.chart"
              [labels]="simplePieChart.labels" [legend]="simplePieChart.legend" [colors]="simplePieChart.colors"
              [responsive]="simplePieChart.responsive">
            </apx-chart>
          </div>
        </div>
      </div> -->

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Week Wise Analysis</h4>
            <apx-chart class="apex-charts" dir="ltr" [series]="columnlabelChart1.series" [chart]="columnlabelChart1.chart"
              [plotOptions]="columnlabelChart1.plotOptions" [yaxis]="columnlabelChart1.yaxis"
              [title]="columnlabelChart1.title" [stroke]="columnlabelChart1.stroke"
              [dataLabels]="columnlabelChart1.dataLabels" [xaxis]="columnlabelChart1.xaxis"
              [legend]="columnlabelChart1.legend" [colors]="columnlabelChart1.colors" [fill]="columnlabelChart1.fill">
            </apx-chart>
          </div>
        </div>
        <!--end card-->
      </div>
  
  
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Month Wise Analysis</h4>
            <apx-chart class="apex-charts" dir="ltr" [series]="columnlabelChart.series" [chart]="columnlabelChart.chart"
              [plotOptions]="columnlabelChart.plotOptions" [yaxis]="columnlabelChart.yaxis"
              [title]="columnlabelChart.title" [stroke]="columnlabelChart.stroke"
              [dataLabels]="columnlabelChart.dataLabels" [xaxis]="columnlabelChart.xaxis"
              [legend]="columnlabelChart.legend" [colors]="columnlabelChart.colors" [fill]="columnlabelChart.fill">
            </apx-chart>
          </div>
        </div>
        <!--end card-->
      </div>
  
    </div>
  </div>
